import React from "react"
import CategoryInfo from "./category-info.component"
import SessionInfo from "./session-info.component"

class DropDown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showSessionInfo: false,
      session: {},
      animationDirection: "fade-down",
      zIndex: -9999,
    }
  }

  toggleArrow = () => {
    if (this.state.showSessionInfo) {
      this.setState({
        showSessionInfo: !this.state.showSessionInfo,
        session: {},
      })
    } else {
      this.props.setDropdownState()
    }
  }

  showSessionInformation = name => {
    const category = this.props.data
    const session = category.sessions.filter(
      session => session.name === name
    )[0]

    this.setState({
      showSessionInfo: !this.state.showSessionInfo,
      animationDirection: "fade-right",
      session: session,
    })
  }

  componentDidMount() {
    setTimeout(
      () =>
        this.setState({
          zIndex: 9999,
        }),
      500
    )
  }

  render() {
    const { loaded } = this.state
    return (
      <div
        ref={this.classRef}
        className="dropdown"
        data-aos="fade-down"
        data-aos-delay="100"
        style={{ zIndex: this.state.zIndex }}
      >
        <div className="dropdown__header" data-aos-offset="300">
          <img
            className="dropdown__arrow"
            src={`${
              this.state.showSessionInfo
                ? "/dropdown-back-arrow.svg"
                : "/dropdown-down-arrow.svg"
            }`}
            onClick={this.toggleArrow}
            alt=""
          />
          <img src="/dropdown-bg.svg" alt="" />
        </div>

        {this.state.showSessionInfo === true ? (
          <SessionInfo
            key={this.state.session.id}
            {...{ ...this.state.session, slug: this.props.data.slug }}
          />
        ) : (
          <CategoryInfo
            {...this.props.data}
            showSessionInformation={this.showSessionInformation}
            animationDirection={this.state.animationDirection}
          />
        )}
      </div>
    )
  }
}

export default DropDown
